import { BRAND_CONFIG } from '../config/brand';

export const APP_NAME = BRAND_CONFIG.name;
export const APP_SLOGAN = BRAND_CONFIG.slogan;
export const APP_DOMAINS = BRAND_CONFIG.domains;
export const HEADER_HEIGHT = 64;

export const ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  COLLECTIONS: '/collections',
  ABOUT: '/about',
  CONTACT: '/contact',
  CART: '/cart',
  CHECKOUT: '/checkout',
  ORDER_CONFIRMATION: '/order-confirmation',
  PAYMENT_STATUS: '/payment/status',
  WISHLIST: '/wishlist',
  LOGIN: '/login',
  REGISTER: '/register',
  ACCOUNT: '/account',
  ADMIN: '/admin',
} as const;

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
// Server origin for resolving uploaded image paths (e.g. /uploads/products/...)
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

export const API_ENDPOINTS = {
  BASE_URL: API_BASE,
  PRODUCTS: '/products',
  CATEGORIES: '/categories',
  ORDERS: '/orders',
  SITE_SETTINGS: '/site-settings',
  AUTH: '/auth',
  CART: '/cart',
  WISHLIST: '/wishlist',
  PAYMENTS: '/payments',
  COUPONS: '/coupons',
  REVIEWS: '/reviews',
} as const;

export const SORT_OPTIONS = [
  { label: 'Newest First', value: 'newest' },
  { label: 'Top Rated', value: 'rating' },
  { label: 'Price: Low to High', value: 'price_asc' },
  { label: 'Price: High to Low', value: 'price_desc' },
] as const; 